const state = {};

const getters = {};
const actions = {
	GenerateDoAuthSecret({ commit }) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('do_connector.generate_auth_secret');
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.auth_secret);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
	ProcessDoAuthResponse({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('do_connector.process_auth_response');
			this._vm.$axios.post(r,{
				response_data: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.response_data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
	SaveConnectorName({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('do_connector.save_connector_name');
			this._vm.$axios.post(r,{
				connector_data: payload
			})
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve();
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
	GetRegionsAndSizes({ commit }, code) {
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('do_connector.get_regions_and_sizes',{
				connector_code: code
			});
			this._vm.$axios.get(r)
				.then(response => {
					if(response.data.call_status === "OK")
					{
						resolve(response.data.regions_and_sizes);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
};
const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
